module.exports = __webpack_public_path__ + "img/icon-coolwallet.4c335d0a.svg";